import React from "react";
import { HOST_PREFIX } from "../../Network/ApiPaths";

function formatDateTimeToDisplay(dateTimeStr) {
  if (!dateTimeStr) return "";
  const [date] = dateTimeStr.split(" "); // take only yyyy-mm-dd
  const [year, month, day] = date.split("-");
  return `${day}-${month}-${year}`;
}
 
class VendorPaymentComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      vendor_id: "",
      invoice_id: "",
      pending_amount:"",
      payment_date: "",
      payment_amount: "",
      balance_after:"",
      payment_mode: "",
      transaction_ref: "",
      pyment_file:"",
      notes: "",
    };
  }

  updatePaymentState = (payment) => {
    this.setState({
      id: payment.id,
      vendor_id: payment.vendor_id,
      invoice_id: payment.invoice_id,
      payment_date: payment.payment_date,
      payment_amount: payment.payment_amount,
      payment_mode: payment.payment_mode,
      transaction_ref: payment.transaction_ref,
      payment_file:payment.payment_file,
      notes: payment.notes,
    });
  };

  render() {
    let filteredPayments = this.props.payments;

    if (this.props.filterVendorId) {
      filteredPayments = filteredPayments.filter(
        (p) => p.vendor_id === this.props.filterVendorId
      );
    }
    if (this.props.filterFromDate) {
      filteredPayments = filteredPayments.filter(
        (p) => p.payment_date >= this.props.filterFromDate
      );
    }
    if (this.props.filterToDate) {
      filteredPayments = filteredPayments.filter(
        (p) => p.payment_date <= this.props.filterToDate
      );
    }

    return (
      <div>
        {/* Add Payment Modal */}
        <div id="paymentModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Record Payment</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label>Vendor</label>
                    <select className="form-control" value={this.props.selectedVendor} onChange={this.props.onVendorChange}>
                      <option value="">Select Vendor</option>
                      {this.props.vendors.map((v) => (
                        <option key={v.id} value={v.id}>{v.vendor_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Invoice</label>
                    <select className="form-control" value={this.props.selectedInvoice} onChange={this.props.onInvoiceChange}>
                      <option value="">Select Invoice</option>
                      {this.props.invoices
                        .filter((inv) => inv.vendor_id === this.props.selectedVendor && inv.status !== "PAID" && inv.status !== "OVERPAID")
                        .map((inv) => (
                          <option key={inv.id} value={inv.id}>
                            {formatDateTimeToDisplay(inv.invoice_date)} - {inv.balance_amount} ({inv.status})
                          </option>
                        ))}
                    </select>
                  </div>
                    <div className="form-group">
                    <label>Pending Amount</label>
                    {this.props.invoices
                        .filter((inv) => inv.vendor_id === this.props.selectedVendor && inv.id === this.props.selectedInvoice)
                        .map((inv) => (<input type="number" className="form-control" value={inv.balance_amount} readOnly  />))}
                    
                  </div>
                  <div className="form-group">
                    <label>Payment Amount</label>
                    <input type="number" className="form-control" value={this.props.paymentAmount} onChange={this.props.onPaymentAmountChange} />
                  </div>
                  <div className="form-group">
                    <label>Balance After</label>
                    {this.props.invoices
                        .filter((inv) => inv.vendor_id === this.props.selectedVendor && inv.id === this.props.selectedInvoice)
                        .map((inv) => (<input type="number" className="form-control" value={inv.balance_amount-this.props.paymentAmount} readOnly  />))}
                    
                  </div>

                  <div className="form-group">
                    <label>Payment Date</label>
                    <input type="date" className="form-control" value={this.props.paymentDate} 
                    min={this.props.invoices.find((inv) => inv.id === this.props.selectedInvoice)?.invoice_date
                          || "" } 
                    onChange={this.props.onPaymentDateChange} />
                  </div>

                  <div className="form-group">
                    <label>Payment Mode</label>
                    <select className="form-control" value={this.props.paymentMode} onChange={this.props.onPaymentModeChange}>
                      <option value="">Select Mode</option>
                      <option value="Cash">Cash</option>
                      <option value="Bank Transfer">Bank Transfer</option>
                      <option value="UPI">UPI</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Credit Card">Credit Card</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Transaction Reference No.</label>
                    <input type="text" className="form-control" value={this.props.transactionRef} onChange={this.props.onTransactionRefChange} />
                  </div>

                  <div className="form-group">
                    <label>Notes</label>
                    <textarea className="form-control" value={this.props.notes} onChange={this.props.onNotesChange} />
                  </div>

                  <div className="form-group">
                    <label>Upload Proof</label>
                    <input type="file" className="form-control" accept="image/*,.pdf" onChange={this.props.onPaymentFileChange} />
                  
                  </div>

                  <button type="submit" className="btn btn-primary" onClick={this.props.addPayment} data-dismiss="modal">
                    Save Payment
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Payment Modal */}
        <div id="paymentEditModal" className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Payment</h4>
                <button type="button" className="close" data-dismiss="modal">
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="form-group">
                    <label>Vendor</label>
                    <select className="form-control" value={this.state.vendor_id} onChange={(e) => this.setState({ vendor_id: e.target.value })}>
                      {this.props.vendors.map((v) => (
                        <option key={v.id} value={v.id}>{v.vendor_name}</option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Invoice</label>
                    <select className="form-control" value={this.state.invoice_id} onChange={(e) => this.setState({ invoice_id: e.target.value })}>
                      {this.props.invoices.filter((inv) => inv.vendor_id === this.state.vendor_id)
                        .map((inv) => (
                          <option key={inv.id} value={inv.id}>
                            {formatDateTimeToDisplay(inv.invoice_date)} - {inv.invoice_amount} ({inv.status})
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Payment Amount</label>
                    <input type="number" className="form-control" value={this.state.payment_amount} onChange={(e) => this.setState({ payment_amount: e.target.value })} />
                  </div>

                  <div className="form-group">
                    <label>Payment Date</label>
                    <input type="date" className="form-control" value={this.state.payment_date} onChange={(e) => this.setState({ payment_date: e.target.value })} />
                  </div>

                  <div className="form-group">
                    <label>Payment Mode</label>
                    <select className="form-control" value={this.state.payment_mode} onChange={(e) => this.setState({ payment_mode: e.target.value })}>
                      <option value="Cash">Cash</option>
                      <option value="Bank Transfer">Bank Transfer</option>
                      <option value="UPI">UPI</option>
                      <option value="Cheque">Cheque</option>
                      <option value="Credit Card">Credit Card</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Transaction Reference No.</label>
                    <input type="text" className="form-control" value={this.state.transaction_ref} onChange={(e) => this.setState({ transaction_ref: e.target.value })} />
                  </div>

                  <div className="form-group">
                    <label>Notes</label>
                    <textarea className="form-control" value={this.state.notes} onChange={(e) => this.setState({ notes: e.target.value })} />
                  </div>
{/* 🔹 File Upload */}
                  <div className="form-group">
                    <label>Upload Invoice Photo</label>
                    <input
                      type="file"
                      className="form-control"
                      defaultValue={this.state.payment_file}
                      accept="image/*,.pdf"
                      onChange={this.props.onPaymentFileChange}
                    />
                    <a
                                        href={`${HOST_PREFIX}images/payments/${this.state.id}/${this.state.payment_file}`}
                                        target="_blank"
                                      >
                                        {this.state.payment_file}
                                      </a>
                  </div>
                  <button type="submit" className="btn btn-primary" onClick={(e) => { e.preventDefault(); this.props.updatePayment(this.state); }} data-dismiss="modal">
                    Update
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Payments Table */}
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center flex-wrap">
            <h3 className="h4">Payments</h3>
            <div className="d-flex flex-wrap" style={{ gap: "10px" }}>
              <select className="form-control" value={this.props.filterVendorId} onChange={this.props.onFilterVendorChange}>
                <option value="">All Vendors</option>
                {this.props.vendors.map((v) => (
                  <option key={v.id} value={v.id}>{v.vendor_name}</option>
                ))}
              </select>
              <input type="date" className="form-control" value={this.props.filterFromDate} onChange={this.props.onFilterFromDateChange} />
              <input type="date" className="form-control" value={this.props.filterToDate} onChange={this.props.onFilterToDateChange} />
              <button className="btn btn-secondary" onClick={this.props.onResetFilters}>Reset Filters</button>
              <button className="btn btn-success" onClick={() => this.props.onExport(filteredPayments)}>Export to Excel</button>
              <button className="btn btn-primary" data-toggle="modal" data-target="#paymentModal">Add Payment</button>
            </div>
          </div>

          <div className="card-body">
            <div className="table-responsive">
              <table className="table text-center">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Vendor</th>
                    <th>Invoice</th>
                    <th>Pending Amount</th>
                    <th>Amount Paid</th>
                    <th>Payment Date</th>
                    <th>Balance After</th>
                    <th>Mode</th>
                    <th>Ref No.</th>
                    <th>Notes</th>
                    <th>Attachment</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPayments.length > 0 ? (
                    filteredPayments.map((p, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{this.props.vendors.find((v) => v.id === p.vendor_id)?.vendor_name}</td>
                        <td>{this.props.invoices.find((inv) => inv.id === p.invoice_id)?.invoice_amount || "-"}</td>
                        <td>{p.pending_amount}</td>
                        <td>{p.payment_amount}</td>
                        <td>{formatDateTimeToDisplay(p.payment_date)}</td>
                        <td>{p.balance_after}</td>
                        <td>{p.payment_mode}</td>
                        <td>{p.transaction_ref}</td>
                        <td>{p.notes}</td>
                       
                          {/* 🔹 Invoice File Link */}
                          
                                                   <td style={{ textAlign: "center" }}>
                                                          <a
                                                            href={`${HOST_PREFIX}images/payments/${p.id}/${p.payment_file}`}
                                                            target="_blank"
                                                          >
                                                            {p.payment_file}
                                                          </a>
                                                        </td>
                        
                        <td>
                          <i className="fa fa-edit mr-2" data-toggle="modal" data-target="#paymentEditModal" onClick={() => this.updatePaymentState(p)}></i>
                          <i className="fa fa-trash" style={{ cursor: "pointer" }} onClick={() => { if (window.confirm("Are you sure you want to delete this payment?")) { this.props.deletePayment(p.id); } }}></i>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr><td colSpan="10">No Payments Found</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default VendorPaymentComponent;
